// extracted by mini-css-extract-plugin
export var downArrow = "_fp-0";
export var infoTooltipIcon = "_fp-3";
export var label = "_fp-1";
export var optionCard = "_fp-4";
export var upArrow = "_fp-2";